import React from 'react';
import PropTypes from 'prop-types';
import clone from 'clone';

import {oeInterfaceManager} from '../../../../react-oe/oe-interface';
import OEInterfaceAdapter from '../../../../react-oe/oe-interface-adapter';
import {OEHideFlags} from '../../../../react-oe/oe-types';
import OELicensingAccessProvider from '../../../../react-oe/oe-licensing-access-provider';
import OENotification from '../../../../lib/notification/oe-notification';
import {OEViewType} from '../../../../lib/oe-types';
import {OEManualViewLinks} from '../../manual-view/oe-manual-view-model';
import OEIconCodes from '../../../../lib/oe-icon-codes';
import {OEFlowNavModalFlags} from '../oe-flow-nav-modal';
import {OENavigationViewComponent} from '../../../../lib/components/oe-navigation-controller';
import OEFNElement from '../../../elements/oe-flow-nav-elements';
import {OEFNHelpEntryFactory} from '../help/oe-flow-nav-help-model';
import OEFNHelp from '../help/oe-flow-nav-help';
import OEFNHelpHandling from '../help/oe-fn-help-handling';
import {OEFNStartSelectionContentFactory} from '../start-selection/oe-fn-start-selection-model';
import OEFlowNavStartSelectionView from '../start-selection/oe-flow-nav-start-selection-view';
import OEFNStartSelectionCurrentItemTitle from '../start-selection/oe-fn-start-selection-current-item-title';
import OEInfoViewController from '../../info-view/oe-info-view-controller';
import OEToolbox from '../../../../lib/tools/oe-toolbox';
import LocalStorage from '../../../../lib/tools/local-storage';
import retardUpdate from '../../../../lib/react/update-retarder';
import {OEFNWelcomeEntryTypes, OEFNWelcomePropDecl, OEFNWelcomeEntryFactory} from './oe-fn-welcome-model';

export default class OEFNWelcome extends React.PureComponent {

    constructor(props) {
        super(props);

        this.oe = oeInterfaceManager.getInterface(this.props.moduleId);

        this.licensingAccess = OELicensingAccessProvider.defaultLicensingAccess();

        this.hasMediaCenterFeature = true;

        this.icons = {
            home:               OEIconCodes.home,
            licensing:          OEIconCodes.key,
            mediaCenter:        OEIconCodes.mediaCenter,
            help:               OEIconCodes.help,
            quickStart:         OEIconCodes.helpView.quickStart,
            manual:             OEIconCodes.helpView.manual,
            startSelection:     OEIconCodes.startSelection,
        };

        this.entries = this.createEntries();

        this.state = {
            dontShowStartViewAtStartUp: LocalStorage.getItem('dontShowStartViewAtStartUp') === 'true',
            strings: {
                home: '',
                licensing: '',
                mediaCenter: '',
                help: '',
                quickStart: '',
                manual: '',
                startSelection: '',
                currentChoice: 'Current',
                dontShowAgainTitle: '',
                dontShowAgainSubtitle: ''
            },
            currentStartSelectionItemTitle: '',
            entries: clone(this.entries)
        };

        this.onLanguageChanged = this.onLanguageChanged.bind(this);
        this.onFeatureAccessChanged = this.onFeatureAccessChanged.bind(this);

        this.onLicensingAccess = this.onLicensingAccess.bind(this);

        this.onCurrentStartSelectionItemTitleChanged = this.onCurrentStartSelectionItemTitleChanged.bind(this);
        this.onItemClick = this.onItemClick.bind(this);
        this.onStartSelectionItemClick = this.onStartSelectionItemClick.bind(this);
        this.onDontShowAgainClicked = this.onDontShowAgainClicked.bind(this);
    }

    componentWillReceiveProps(nextProps)   {
        let entriesUpdated = false;
        if(!OEToolbox.shallowEqual(nextProps.entries, this.props.entries, true))  {
            this.updateEntries(nextProps);
            entriesUpdated = false;
        }

        if(nextProps.locStringPrefix !== this.props.locStringPrefix)  {
            this.updateLanguage(nextProps, !entriesUpdated);
        }
    }

    onConnect()  {
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.languageChanged, this.onLanguageChanged);
        this.oe.sharedNotificationCenter.register(this.oe.NotificationName.featureAccessChanged, this.onFeatureAccessChanged);
    }

    onRelease()    {
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.languageChanged, this.onLanguageChanged);
        this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.featureAccessChanged, this.onFeatureAccessChanged);
    }

    updateLanguage(props, updateEntries = true)   {
        if(!this.oe.isReady())  return;
        props = props || this.props;
        let si = this.oe.sharedInterface;

        this.setState({
            strings: {
                home: si.getLocalizedStringEnc(props.locStringPrefix + 'welcome_view_home'),
                licensing: si.getLocalizedStringEnc(props.locStringPrefix + 'welcome_view_license_manager'),
                mediaCenter: si.getLocalizedStringEnc(props.locStringPrefix + 'welcome_view_pres'),
                help: si.getLocalizedStringEnc(props.locStringPrefix + 'welcome_view_help'),
                quickStart: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_help'),
                manual: si.getLocalizedStringEnc(props.locStringPrefix + 'help_view_manual'),
                startSelection: si.getLocalizedStringEnc(props.locStringPrefix + 'welcome_view_start_selection'),
                currentChoice: si.getLocalizedStringEnc(props.locStringPrefix + 'welcome_view_current_start_selection'),
                dontShowAgainTitle: si.getLocalizedStringEnc(props.locStringPrefix + 'welcome_view_dont_show_again_title'),
                dontShowAgainSubtitle: si.getLocalizedStringEnc(props.locStringPrefix + 'welcome_view_dont_show_again_subtitle'),
            }
        });

        if(updateEntries)   this.updateEntriesText();
    }

    isMasked(entry) {
        if(entry.type === OEFNWelcomeEntryTypes.mediaCenter && !this.hasMediaCenterFeature)   return true;
        if(!entry.mask) return false;
        const mask = entry.mask;
        const licenseValid = !this.licensingAccess.isLicensing || this.licensingAccess.isValid;

        if(mask.licensingAccess && !mask.licensingAccess(this, entry, this.licensingAccess, this.oe))    return true;

        if(typeof(mask.licenseValid) === 'boolean' && mask.licenseValid !== licenseValid)   return true;

        return false;
    }

    mapEntries(entries) {
        if(!Array.isArray(entries))   return [];

        let mapped = [];

        entries.forEach(entry => {
            if(this.isMasked(entry))    return;

            if(entry.type === OEFNWelcomeEntryTypes.maskBlock)  {
                mapped.push(...this.mapEntries(entry.entries));
                return;
            }

            let ret = {
                type: entry.type,
                enabled: entry.enabled,
                proto: entry
            };

            if(this.oe.isReady())   {
                let si = this.oe.sharedInterface;
                ret.text = entry.string ? entry.string : (entry.stringId ? si.getLocalizedStringEnc(entry.stringId) : undefined);
                ret.link = entry.link !== undefined && entry.link !== null ? entry.link : (entry.linkId ? si.getLocalizedStringEnc(entry.linkId) : undefined);
            }

            mapped.push(ret);
        });

        return mapped;
    }

    createEntries(props)   {
        props = props || this.props;
        return this.mapEntries(props.entries);
    }

    updateEntriesText(stateUpdate = true)    {
        if(!this.oe.isReady())  return;
        let si = this.oe.sharedInterface;

        this.entries.forEach(entry => {
            entry.text = entry.proto.string ? entry.proto.string : (entry.proto.stringId ? si.getLocalizedStringEnc(entry.proto.stringId) : undefined);
            entry.link = entry.proto.link !== undefined && entry.proto.link !== null ? entry.proto.link : (entry.proto.linkId ? si.getLocalizedStringEnc(entry.proto.linkId) : undefined);
        });

        if(stateUpdate) this.setState({entries: clone(this.entries)});
    }

    updateEntries(props)    {
        this.entries = this.createEntries(props);
        this.setState({entries: clone(this.entries)});
    }

    updateFeatureAccess(featureSet, updateEntries = true) {
        featureSet = featureSet || this.oe.sharedInterface.getUIControllerFeatureAccess().getFeatureSet();
        let hasMediaCenterFeature = featureSet.hasFeature(this.oe.Module.Feature.media);
        featureSet.delete();

        if(hasMediaCenterFeature != this.hasMediaCenterFeature) {
            this.hasMediaCenterFeature = hasMediaCenterFeature;
            if(updateEntries)   this.updateEntries();
        }
    }

    updateState(released)   {
        if(!this.oe.isReady() || released === true) return;

        retardUpdate(this, () => {
            this.updateLanguage(undefined, false);
            this.updateFeatureAccess(undefined, false);
            this.updateEntries();
        });
    }

    onLanguageChanged() {
        this.updateLanguage();
    }

    onFeatureAccessChanged(message, userInfo)    {
        this.updateFeatureAccess(userInfo.newFeatureSet);
    }

    onLicensingAccess(licensingAccess)  {
        this.licensingAccess = licensingAccess;
        this.updateEntries();
    }

    renderEntries() {
        let ret = [];
        let nextWithSpacer = false;

        for(let i = 0; i < this.state.entries.length; ++i)  {
            let entry = this.state.entries[i];

            let spacer = nextWithSpacer;
            let element;

            if(entry.type === OEFNWelcomeEntryTypes.text)   {
                let style = {};
                if(entry.proto.fontSize)  style.fontSize = entry.proto.fontSize;
                if(entry.proto.minHeight) style.minHeight = entry.proto.minHeight;

                element = (
                    <OEFNElement.Block
                        className={entry.proto.className}
                        style={style}
                        content={entry.text}
                        html={entry.proto.html}
                    />
                );
                nextWithSpacer = false;

            } else if(entry.type === OEFNWelcomeEntryTypes.button)   {

                element = (
                    <OEFNElement.Button
                        className={entry.proto.className}
                        id={entry.proto.id}
                        title={entry.text}
                        enabled={entry.enabled}
                        link={entry.link}
                        entry={entry.proto}
                        onClick={this.onItemClick}
                    />
                );

            } else if(entry.type === OEFNWelcomeEntryTypes.spacer)   {

                element = (
                    <OEFNElement.Spacer
                        className={entry.proto.className}
                        height={entry.proto.height}
                    />
                );
                nextWithSpacer = false;

            } else if(entry.type === OEFNWelcomeEntryTypes.dontShowCheckbox)   {

                element = (
                    <OEFNElement.Checkbox
                        className={entry.proto.className}
                        title={entry.text ? entry.text : this.state.strings.dontShowAgainTitle}
                        subtitle={entry.proto.noSubtitle ? null : this.state.strings.dontShowAgainSubtitle}
                        checked={this.state.dontShowStartViewAtStartUp}
                        onClick={this.onDontShowAgainClicked}
                    />
                );
                nextWithSpacer = false;

            } else if(entry.type === OEFNWelcomeEntryTypes.currentStartSelectionTitle)   {
                let style = {};
                if(entry.proto.fontSize)  style.fontSize = entry.proto.fontSize;
                if(entry.proto.minHeight) style.minHeight = entry.proto.minHeight;

                element = (
                    <OEFNElement.Block
                        className={entry.proto.className}
                        style={style}
                        content={this.state.strings.currentChoice + ': ' + this.state.currentStartSelectionItemTitle}
                    />
                );
                nextWithSpacer = false;

            } else {

                let text = entry.text ? entry.text : this.state.strings[entry.type];

                element = (
                    <OEFNElement.Menu
                        className={entry.proto.className}
                        id={entry.proto.id}
                        iconCode={entry.proto.icon ? entry.proto.icon : this.icons[entry.type]}
                        html={entry.proto.html ? text : null}
                        title={entry.proto.html ? null : text}
                        enabled={entry.enabled}
                        link={entry.link}
                        entry={entry.proto}
                        onClick={this.onItemClick}
                    >
                        {!entry.proto.logo ? null :
                            <div className="logo">
                                <img src={entry.proto.logo}/>
                            </div>
                        }
                    </OEFNElement.Menu>
                );
                nextWithSpacer = true;
            }

            ret.push(
                <React.Fragment key={i.toString() + '_element'}>
                    {nextWithSpacer && spacer ? <OEFNElement.Spacer height={(typeof(entry.proto.spacerHeight) === 'number' || typeof(entry.proto.spacerHeight) === 'string' ? entry.proto.spacerHeight : this.props.autoSpacerHeight)}/> : null}
                    {element}
                </React.Fragment>
            );
        }

        return ret;
    }

    render() {
        return (
            <React.Fragment>
                <OEInterfaceAdapter moduleId={this.props.moduleId} receiver={this}/>
                <OELicensingAccessProvider moduleId={this.props.moduleId} omitUpdateOnRelease={true} onLicensingAccess={this.onLicensingAccess}/>

                <OEFNStartSelectionCurrentItemTitle moduleId={this.props.moduleId} onTitleChanged={this.onCurrentStartSelectionItemTitleChanged}/>

                <OEFNElement.View>
                    {this.renderEntries()}
                </OEFNElement.View>

                <OENavigationViewComponent
                    navigationController={this.props.navigationController}
                    compId={'welcome_' + OEFNWelcomeEntryTypes.help}
                    showLogo={this.props.help.showLogo}
                    deferred={true}
                >
                    <OEFNHelp
                        target={this.props.target}
                        appComponent={this.props.appComponent}
                        moduleId={this.props.moduleId}
                        navigationController={this.props.navigationController}
                        locStringPrefix={this.props.help.locStringPrefix ? this.props.help.locStringPrefix : this.props.locStringPrefix}
                        entries={this.props.help.entries}
                        manualViewLinks={this.props.help.manualViewLinks}
                        autoSpacerHeight={typeof(this.props.help.autoSpacerHeight) === 'number' || typeof(this.props.help.autoSpacerHeight) === 'string' ? this.props.help.autoSpacerHeight : this.props.autoSpacerHeight}
                        parent={this.props.parent}
                    />
                </OENavigationViewComponent>

                <OENavigationViewComponent
                    navigationController={this.props.navigationController}
                    compId={'welcome_' + OEFNWelcomeEntryTypes.quickStart}
                    deferred={true}
                >
                    <OEFNHelpHandling
                        appComponent={this.props.appComponent}
                        moduleId={this.props.moduleId}
                        navigationController={this.props.navigationController}
                        locStringPrefix={this.props.locStringPrefix}
                    />
                </OENavigationViewComponent>

                <OENavigationViewComponent
                    navigationController={this.props.navigationController}
                    compId={'welcome_' + OEFNWelcomeEntryTypes.startSelection}
                    deferred={true}
                    showLogo={true}
                >
                    <OEFlowNavStartSelectionView
                        moduleId={this.props.moduleId}
                        navigationController={this.props.navigationController}
                        locStringPrefix={this.props.locStringPrefix}
                        onItemClick={this.onStartSelectionItemClick}
                    />
                </OENavigationViewComponent>

            </React.Fragment>
        );
    }

    onItemClick(id, sender) {
        let app = this.props.appComponent ? this.props.appComponent.app : undefined;
        let uiLayer = this.props.appComponent ? this.props.appComponent.uiLayer : undefined;
        let startView = uiLayer ? uiLayer.startView : undefined;

        //
        let entry = sender && sender.props ? sender.props.entry : undefined;
        let type = entry ? entry.type : undefined;

        //
        let navControllerItemUserData = {
            title: entry ? entry.viewTitle : undefined,
            flowNavModalFlags: entry && typeof(sender.props.entry.flowNavModalFlags) === 'number' ? sender.props.entry.flowNavModalFlags : 0
        };

        if(type === OEFNWelcomeEntryTypes.home)   {

            if(startView) startView.close();
            if(app) app.reset();

        } else if(type === OEFNWelcomeEntryTypes.licensing && uiLayer && uiLayer.infoView)   {

            const useInfoListener = this.props.parent && this.oe.isReady();

            if(useInfoListener)   {
                let listener = {parent: this.props.parent, oe: this.oe};

                listener.onOpenStateChanged = function(message, userInfo)    {
                    if(userInfo.type !== OEViewType.info || userInfo.isOpen || userInfo.sender !== uiLayer.infoView)   return;
                    this.parent.setOpen(true);
                    uiLayer.infoView.setOptions(undefined);
                    this.unregister();
                }.bind(listener);

                listener.onLicensingProductActivationChanged = function(message, userInfo)    {
                    if(!userInfo.isValid)   return;
                    this.unregister();
                    uiLayer.infoView.setOpen(false);
                    uiLayer.infoView.setOptions(undefined);
                    this.parent.setOpen(true);
                }.bind(listener);

                listener.unregister = function()    {
                    uiLayer.notificationCenter.unregister(OENotification.viewOpenStateChanged, this.onOpenStateChanged);
                    if(this.oe.isReady())  this.oe.sharedNotificationCenter.unregister(this.oe.NotificationName.licensingProductActivationChanged, this.onLicensingProductActivationChanged);
                }.bind(listener);

                uiLayer.notificationCenter.register(OENotification.viewOpenStateChanged, listener.onOpenStateChanged);

                this.oe.sharedNotificationCenter.register(this.oe.NotificationName.licensingProductActivationChanged, listener.onLicensingProductActivationChanged);
            }

            uiLayer.infoView.setOptions({coreHideFlags: OEHideFlags.scene, blurBackground: true, className: 'clear-backdrop'});
            uiLayer.infoView.openItem(OEInfoViewController.itemTypes.licensing);

            if(useInfoListener)   this.props.parent.setOpen(false);

        } else if(type === OEFNWelcomeEntryTypes.mediaCenter)   {

            if(startView)   startView.close();

            if(this.oe.isReady())   {
                if(uiLayer) uiLayer.closeAllPopovers();
                this.oe.sharedInterface.setUIControllerVisible(true, this.oe.Module.UIControllerType.media_center);
            }

        } else if(type === OEFNWelcomeEntryTypes.help) {

            this.props.navigationController.push('welcome_' + OEFNWelcomeEntryTypes.help, navControllerItemUserData);

        } else if(type === OEFNWelcomeEntryTypes.quickStart)   {

            this.props.navigationController.push('welcome_' + OEFNWelcomeEntryTypes.quickStart, navControllerItemUserData);

        } else if(type === OEFNWelcomeEntryTypes.manual && uiLayer && uiLayer.manualView)   {

            let options = {link: sender.props.link ? sender.props.link : OEManualViewLinks.app};

            if(Array.isArray(this.props.help.manualViewLinks)) options.links = this.props.help.manualViewLinks;

            uiLayer.manualView.setOpen(true, options);

        } else if(type === OEFNWelcomeEntryTypes.startSelection)   {

            if(entry)   {
                if(Array.isArray(entry.startSelection)) {                                                   // module or category array

                    navControllerItemUserData.viewProps = {content: OEFNStartSelectionContentFactory.areCategories(entry.startSelection) ? {id: entry.targetType, isHidden: true, categories: entry.startSelection} : entry.startSelection};

                } else if(OEFNStartSelectionContentFactory.isModuleOrCategory(entry.startSelection)) {      // module or category item

                    navControllerItemUserData.viewProps = {content: OEFNStartSelectionContentFactory.isCategory(entry.startSelection) ? Object.assign({id: entry.targetType}, entry.startSelection) : entry.startSelection};

                } else if(typeof(entry.startSelection) === 'object' && entry.startSelection)    {           // start selection view props

                    let viewProps = {...entry.startSelection};

                    if(OEFNStartSelectionContentFactory.areCategories(viewProps.content))    {
                        viewProps.content = {id: entry.targetType, isHidden: true, categories: viewProps.content};
                    } else if(OEFNStartSelectionContentFactory.isCategory(viewProps.content)) {
                        viewProps.content = Object.assign({id: entry.targetType}, viewProps.content);
                    }

                    navControllerItemUserData.viewProps = viewProps;
                }
            }

            this.props.navigationController.push('welcome_' + OEFNWelcomeEntryTypes.startSelection, navControllerItemUserData);

        } else if(type === OEFNWelcomeEntryTypes.urlLink || typeof(sender.props.link) === 'string')   {

            if(typeof(sender.props.link) !== 'string')  {
                console.log('Warning - no proper link provided to welcome entry of typ URL link');
            } else {
                window.open(sender.props.link);
            }
        }

        //
        if(entry && entry.onClick)  entry.onClick(id, this, entry);
    }

    onCurrentStartSelectionItemTitleChanged(sender, title)  {
        this.setState({currentStartSelectionItemTitle: title});
    }

    onStartSelectionItemClick(sender, item)   {
        if(!item.target)    return;

        let nav = this.props.navigationController;
        if(nav && nav.top() && nav.top().view.props.compId === 'welcome_' + OEFNWelcomeEntryTypes.startSelection)   {
            nav.pop('welcome_' + OEFNWelcomeEntryTypes.startSelection, {flowNavModalFlags: OEFlowNavModalFlags.closeOnPop});
        }
    }

    onDontShowAgainClicked()    {
        let newState = !this.state.dontShowStartViewAtStartUp;
        LocalStorage.setItem('dontShowStartViewAtStartUp', newState ? 'true' : 'false');
        this.setState({dontShowStartViewAtStartUp: newState});
    }
}

OEFNWelcome.defaultProps = {
    moduleId:                   '',
    locStringPrefix:            '',
    entries:                    OEFNWelcomeEntryFactory.buildDef(),
    autoSpacerHeight:           '2.125em',    // 34px
    help: {
        showLogo:               false,
        entries:                OEFNHelpEntryFactory.buildDef(),
        autoSpacerHeight:       OEFNHelp.defaultProps.autoSpacerHeight
    }
};

OEFNWelcome.propTypes = Object.assign({
    moduleId:                   PropTypes.string
}, OEFNWelcomePropDecl);